import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { AccountTypes } from '../../../components/changeUser/accountTypes.enum';
import { Button } from '../../../components/button/button';
import { di } from '../../../state/inversify.config';
import { AddPlayerDomain } from '../addPlayer.domain';

interface AddPlayerButtonProps {
  onPress: () => void;
  size?: 'small' | 'medium' | 'large';
}
export function AddPlayerButton({ onPress, size }: AddPlayerButtonProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const addPlayerDomain = di.get<AddPlayerDomain>(AddPlayerDomain);
  const maxNumberOfPlayersReached =
    addPlayerDomain.useMaxNumberOfPlayersReachedSelector();
  const accountType = addPlayerDomain.useAccountTypeSelector();

  return (
    <Button
      color="secondary"
      type="submit"
      variant="contained"
      disabled={maxNumberOfPlayersReached}
      size={size}
      startIcon={<AddIcon />}
      sx={{ my: 2 }}
      onClick={onPress}
      label={
        accountType === AccountTypes.Clinic ? t('ADD_PATIENT') : t('ADD_PLAYER')
      }
    />
  );
}
